// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 177 ? "home" : chunkId) + "." + {"177":"af4a5800","787":"10cf512c","842":"1e067a49"}[chunkId] + ".chunk.js";
};